import React, { useEffect, useState } from "react";
import PageWrapper from "./PageWrapper";
import "./SignupCommon.css"; 
import image from "../../assets/images/party.png"; 
import downloadAppBtn1 from "../../assets/images/downloadAppBtn1.png";
import downloadAppBtn2 from "../../assets/images/downloadAppBtn2.png";
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
declare global {
  interface Window {
    EF?: {
      click: (params: {
        offer_id: string | null;
        affiliate_id?: string | null;
        sub1?: string | null;
        sub2?: string | null;
        sub3?: string | null;
        sub4?: string | null;
        sub5?: string | null;
        uid?: string | null;
        source_id?: string | null;
        transaction_id?: string | null;
      }) => void;
      conversion: (params: {
        offer_id: number;
        amount?: number;
        affiliate_id?: string;
      }) => void;
    };
    fbq: (...args: any[]) => void;
  }
}

const SignupPage24 = () => {
  const [uuidConversionValue, setUuidConversionValue] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

const safeNavigate = (path: string) => {
  if (location.pathname !== path) {
    navigate(path, { replace: true });
  }
};
  // useEffect(() => {
  //   localStorage.setItem("step-18-completed", "true");
  //   const timer = setTimeout(() => {
  //     localStorage.clear();
  //     navigate("/");
  //   }, 5000);
  //   return () => clearTimeout(timer);
  // }, []);
  
  useEffect(() => {
    const isNewFunnel = localStorage.getItem("isNewFunnel");
    const step16Completed = localStorage.getItem("step-16-completed");
    const step17Completed = localStorage.getItem("step-17-completed");
  
    if (isNewFunnel) {
      if (step17Completed || step16Completed) {
        safeNavigate("/getting-started/step-18");
      } else {
        safeNavigate("/getting-started/step-16");
      }
      return;
    }
  
    if (step17Completed || step16Completed) {
      safeNavigate("/getting-started/step-18");
    } else {
      safeNavigate("/getting-started/step-16");
    }
  }, []);
  

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <div className="thank-you-page-container">
          <div className="thank-you-image-container">
            <img src={image} alt="Thank You" className="thank-you-image" />
          </div>
          <p className="thank-you-heading">
            Congrats! You have completed the process. You are one step closer to
            achieving your goals.
          </p>
          <p className="thank-you-description">
            Please check your inbox for updates about next steps and delivery.
          </p>

          <div className="thankyou-row-container">
            <div className="thankyou-page-banner">
              {/* Left Side Text */}
              <div className="thankyou-page-banner-left">
                Download the Claya app
                <br />
                <span className="download-app-desc">
                  Your personalized weight loss companion
                </span>
              </div>
            </div>

            {/* Buttons */}
            <div className="download-app-button-container">
              <a
                href="https://play.google.com/store/apps/details?id=com.claya.health"
                target="_blank"
                rel="noopener noreferrer"
                className="image-button"
              >
                <img
                  src={downloadAppBtn1}
                  alt="Download App Button 1"
                  className="button-image"
                />
              </a>
              <a
                href="https://apps.apple.com/us/app/claya-health/id6739589103"
                target="_blank"
                rel="noopener noreferrer"
                className="image-button"
              >
                <img
                  src={downloadAppBtn2}
                  alt="Download App Button 2"
                  className="button-image"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage24;
